import { render } from "./TagsDashboard.vue?vue&type=template&id=03741c64"
import script from "./TagsDashboard.vue?vue&type=script&lang=js"
export * from "./TagsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ravanjeyhan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__